export const FETCH_SUCCESS = 'session/FETCH_SUCCESS'
export const FETCH_FAILURE = 'session/FETCH_FAILURE'
export const FETCH_STARTED = 'session/FETCH_STARTED'
